module.exports = __webpack_public_path__ + "media/packs/images/flags/MM-c37299bdf72d2223da8dccc39323175c.svg";